/* OOAK cart upsell — fires the instant a walking stick is added to cart.
 * - Detects the add at the cart-request level (works from any page/button)
 * - Replaces Showcase's own "added to cart" popup for stick-adds by hooking
 *   showThemeModal (non-stick adds keep the native popup unchanged)
 * - Leads with the H&F bundle, then one rotated Kina under "Goes well with this"
 * - One tap ADDS the item to the existing cart AND applies its discount code
 * - Prices read the buyer's active currency from the cart (AUD $198 / NZD $198)
 * - The drawer has no backdrop and does not lock the page, so the product page
 *   stays fully visible and tappable behind it
 */
(function () {
  'use strict';

  var BUNDLE = {
    title: 'Handle sleeve & foot bundle',
    subtitle: 'Personalise your Uno with a colour-matched handle, sleeve and rubber foot.',
    price: 29.00,
    discountedPrice: 20.00,
    saving: 9,
    code: 'BUNDLE9',
    image: 'https://cdn.shopify.com/s/files/1/0644/4453/0844/files/OOAK_uno_accessory_handles_97db0128-81b4-4d1b-8406-f4de70f55588.jpg?v=1753523341',
    variants: [
      { id: '45012436254876', label: 'Kōwhai' },
      { id: '45012436189340', label: 'Coral' },
      { id: '45012436222108', label: 'Pacific' },
      { id: '45012436156572', label: 'Graphite' }
    ]
  };

  var KINAS = [
    { title: 'Kina. Void Blue', price: 198.00, discountedPrice: 148.50, image: 'https://cdn.shopify.com/s/files/1/0644/4453/0844/files/OOAK_kina_BLUE_4K_05_sml.png?v=1762656744', variantId: '45241404883100' },
    { title: 'Kina. Tangerine', price: 198.00, discountedPrice: 148.50, image: 'https://cdn.shopify.com/s/files/1/0644/4453/0844/files/OOAK_kina_ORANGE_4K_05.png?v=1762488401', variantId: '45525979529372' },
    { title: 'Kina. Kānuka', price: 198.00, discountedPrice: 148.50, image: 'https://cdn.shopify.com/s/files/1/0644/4453/0844/files/OOAK_kina_PINK_4K_05.png?v=1762487024', variantId: '45525769584796' },
    { title: 'Kina. Ember', price: 198.00, discountedPrice: 148.50, image: 'https://cdn.shopify.com/s/files/1/0644/4453/0844/files/OOAK_kina_RED_4K_05_sml.png?v=1763321152', variantId: '45525970878620' }
  ];
  var KINA_CODE = 'KINA25';

  function isStick(item) {
    return !!item && item.product_type === 'Walking stick' &&
      !!item.vendor && item.vendor.toLowerCase() === 'ooak';
  }

  function money(code, n) {
    var s = (n % 1 === 0) ? n.toFixed(0) : n.toFixed(2);
    return code + ' $' + s;
  }

  // Add the upsell variant to the EXISTING cart (keeps the walking stick and
  // anything else already there), then apply the discount code via a permalink
  // whose redirect target is /cart — which does NOT modify cart contents.
  // NB: the old '/discount/CODE?redirect=/cart/VARIANT:1' form used a cart
  // permalink that REPLACED the whole cart, wiping the stick before checkout.
  function addAndApply(code, variantId) {
    var go = function () { window.location.href = '/discount/' + code + '?redirect=/cart'; };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(go).catch(go);
  }

  // Pick a Kina, avoiding the one shown last so a second add rotates colour.
  function pickKina() {
    var last = null;
    try { last = sessionStorage.getItem('ooak_last_kina'); } catch (e) {}
    var pool = KINAS.filter(function (k) { return k.variantId !== last; });
    if (!pool.length) pool = KINAS;
    var k = pool[Math.floor(Math.random() * pool.length)];
    try { sessionStorage.setItem('ooak_last_kina', k.variantId); } catch (e) {}
    return k;
  }

  function injectStyles() {
    if (document.getElementById('ooak-uc-styles')) return;
    var s = document.createElement('style');
    s.id = 'ooak-uc-styles';
    s.textContent = [
      '#ooak-uc-sheet{position:fixed;bottom:0;left:0;right:0;z-index:10001;background:#fff;border-radius:16px 16px 0 0;max-height:85vh;max-height:85dvh;overflow-y:auto;-webkit-overflow-scrolling:touch;transform:translateY(100%);transition:transform .35s cubic-bezier(.32,0,.15,1);box-shadow:0 -4px 32px rgba(0,0,0,.18);}',
      '#ooak-uc-sheet.show{transform:translateY(0);}',
      '@media (min-width:680px){#ooak-uc-sheet{left:auto;right:24px;width:440px;border-radius:12px 12px 0 0;}}',
      '.ooak-uc-drag-handle{width:36px;height:4px;background:#ddd;border-radius:2px;margin:12px auto 0;}',
      '@media (min-width:680px){.ooak-uc-drag-handle{display:none;}}',
      '.ooak-uc-sheet-header{display:flex;align-items:flex-start;justify-content:space-between;padding:1rem 1.25rem .75rem;position:sticky;top:0;background:#fff;z-index:3;}',
      '.ooak-uc-heading{font-family:"Playfair Display",serif;font-size:20px;font-weight:400;color:#111;margin:0;flex:1;}',
      '.ooak-uc-close{background:none;border:none;cursor:pointer;padding:6px;margin:-2px -4px 0 0;color:#888;display:flex;align-items:center;border-radius:50%;transition:background .15s;flex-shrink:0;}',
      '.ooak-uc-close:hover{background:#f5f5f5;}',
      '.ooak-uc-body{padding:0 1.25rem 2rem;font-family:"Jost",sans-serif;}',
      '.ooak-uc-section-title{font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#666;border-top:1px solid #eee;padding-top:.85rem;margin-bottom:.5rem;}',
      '.ooak-uc-section-title:first-child{border-top:none;padding-top:0;}',
      '.ooak-uc-kina-desc{font-size:12px;color:#888;font-weight:300;margin-bottom:.75rem;font-style:italic;}',
      '.ooak-uc-card{display:flex;gap:.85rem;align-items:flex-start;background:#fafafa;border-radius:8px;padding:.85rem;margin-bottom:.75rem;}',
      '.ooak-uc-img{width:80px;height:80px;object-fit:cover;border-radius:6px;flex-shrink:0;}',
      '.ooak-uc-info{flex:1;min-width:0;}',
      '.ooak-uc-name{font-size:13px;font-weight:500;color:#111;margin-bottom:2px;}',
      '.ooak-uc-desc{font-size:11px;color:#777;font-weight:300;line-height:1.5;margin-bottom:5px;}',
      '.ooak-uc-price{font-size:13px;color:#111;margin-bottom:2px;}',
      '.ooak-uc-was{text-decoration:line-through;color:#bbb;margin-right:4px;}',
      '.ooak-uc-badge{background:#111;color:#fff;font-size:9px;letter-spacing:.06em;padding:2px 5px;border-radius:2px;margin-left:2px;vertical-align:middle;}',
      '.ooak-uc-select-label{display:block;font-size:10px;color:#666;letter-spacing:.06em;text-transform:uppercase;margin:5px 0 3px;}',
      '#ooak-uc-sheet select.ooak-uc-select{display:block;width:100%;padding:8px 10px;border:1px solid #ddd;border-radius:4px;font-family:"Jost",sans-serif;font-size:14px;color:#111;background:#fff;margin-bottom:7px;-webkit-appearance:auto;appearance:auto;}',
      '.ooak-uc-btn{display:block;width:100%;box-sizing:border-box;padding:11px 0;text-align:center;background:#111;color:#fff;font-family:"Jost",ssans-serif;font-size:11px;font-weight:500;letter-spacing:.08em;text-transform:uppercase;text-decoration:none;border-radius:4px;transition:opacity .15s;-webkit-tap-highlight-color:transparent;}',
      '.ooak-uc-btn:hover,.ooak-uc-btn:active{opacity:.82;color:#fff;}'
    ].join('');
    document.head.appendChild(s);
  }

  function buildSheet(currency) {
    var kina = pickKina();

    var opts = BUNDLE.variants.map(function (v) {
      return '<option value="' + v.id + '">' + v.label + '</option>';
    }).join('');

    var bundleCard =
      '<p class="ooak-uc-section-title">Handle &amp; foot bundle — save ' + money(currency, BUNDLE.saving) + '</p>' +
      '<div class="ooak-uc-card">' +
        '<img src="' + BUNDLE.image + '" alt="' + BUNDLE.title + '" class="ooak-uc-img" loading="lazy">' +
        '<div class="ooak-uc-info">' +
          '<p class="ooak-uc-name">' + BUNDLE.title + '</p>' +
          '<p class="ooak-uc-desc">' + BUNDLE.subtitle + '</p>' +
          '<p class="ooak-uc-price"><span class="ooak-uc-was">' + money(currency, BUNDLE.price) + '</span> ' + money(currency, BUNDLE.discountedPrice) + ' <span class="ooak-uc-badge">save ' + money(currency, BUNDLE.saving) + '</span></p>' +
          '<label class="ooak-uc-select-label" for="ooak-bundle-variant">Colour</label>' +
          '<select class="ooak-uc-select" id="ooak-bundle-variant">' + opts + '</select>' +
          '<a href="#" id="ooak-bundle-link" class="ooak-uc-btn" data-code="' + BUNDLE.code + '" data-variant="' + BUNDLE.variants[0].id + '">Add to cart</a>' +
        '</div>' +
      '</div>';

    var kinaCard =
      '<p class="ooak-uc-section-title">Goes well with this</p>' +
      '<p class="ooak-uc-kina-desc">A place for your stick (or umbrella) to park by the door.</p>' +
      '<div class="ooak-uc-card">' +
        '<img src="' + kina.image + '" alt="' + kina.title + '" class="ooak-uc-img" loading="lazy">' +
        '<div class="ooak-uc-info">' +
          '<p class="ooak-uc-name">' + kina.title + '</p>' +
          '<p class="ooak-uc-price"><span class="ooak-uc-was">' + money(currency, kina.price) + '</span> ' + money(currency, kina.discountedPrice) + ' <span class="ooak-uc-badge">25% off</span></p>' +
          '<a href="#" class="ooak-uc-btn" data-code="' + KINA_CODE + '" data-variant="' + kina.variantId + '">Add to cart</a>' +
        '</div>' +
      '</div>';

    return '<div class="ooak-uc-drag-handle"></div>' +
      '<div class="ooak-uc-sheet-header">' +
        '<h2 class="ooak-uc-heading">A little colour pop you can swap.</h2>' +
        '<button class="ooak-uc-close" id="ooak-uc-close" aria-label="Close">' +
          '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">' +
          '<line x1="3" y1="3" x2="15" y2="15" stroke="#888" stroke-width="1.5" stroke-linecap="round"/>' +
          '<line x1="15" y1="3" x2="3" y2="15" stroke="#888" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<div class="ooak-uc-body">' + bundleCard + kinaCard + '</div>';
  }

  function ensureNodes() {
    if (document.getElementById('ooak-uc-sheet')) return;
    var sheet = document.createElement('div');
    sheet.id = 'ooak-uc-sheet';
    document.body.appendChild(sheet);
  }

  function openSheet(currency) {
    injectStyles();
    ensureNodes();
    var sheet = document.getElementById('ooak-uc-sheet');
    sheet.innerHTML = buildSheet(currency);

    document.getElementById('ooak-uc-close').addEventListener('click', closeSheet);

    var sel = document.getElementById('ooak-bundle-variant');
    var link = document.getElementById('ooak-bundle-link');
    if (sel && link) {
      sel.addEventListener('change', function () { link.setAttribute('data-variant', sel.value); });
    }
    Array.prototype.forEach.call(sheet.querySelectorAll('.ooak-uc-btn'), function (btn) {
      btn.addEventListener('click', function (e) {
        if (e && e.preventDefault) e.preventDefault();
        try { sessionStorage.setItem('ooak_uc_dismissed', '1'); } catch (err) {}
        var code = btn.getAttribute('data-code');
        var variantId = btn.getAttribute('data-variant');
        if (!variantId) return;
        addAndApply(code, variantId);
      });
    });

    // No backdrop, no scroll lock — the page stays visible and tappable behind the drawer.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { sheet.classList.add('show'); });
    });
  }

  function closeSheet() {
    var sheet = document.getElementById('ooak-uc-sheet');
    if (sheet) sheet.classList.remove('show');
    try { sessionStorage.setItem('ooak_uc_dismissed', '1'); } catch (e) {}
  }

  // Confirm a stick is in the cart, read the buyer's currency, then open.
  function openFromCart(force) {
    if (!force) {
      var dismissed = null;
      try { dismissed = sessionStorage.getItem('ooak_uc_dismissed'); } catch (e) {}
      if (dismissed) return;
    }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!(cart.items || []).some(isStick)) return;
        openSheet(cart.currency || 'NZD');
      })
      .catch(function () {});
  }

  // Open the offer drawer a beat after the add is confirmed. De-duped so the
  // showThemeModal hook and the no-popup fallback can't both fire it.
  var lastDrawerAttempt = 0;
  function openDrawer() {
    var now = Date.now();
    if (now - lastDrawerAttempt < 1500) return;
    lastDrawerAttempt = now;
    setTimeout(function () { openFromCart(true); }, 250);
  }

  // --- Add detection -> single source of truth for "was the last add a stick?" ---
  var lastAdd = null;      // { isStick: bool, at: number }
  var addWaiters = [];

  function signalAdd(isStickAdd) {
    lastAdd = { isStick: isStickAdd, at: Date.now() };
    var waiters = addWaiters;
    addWaiters = [];
    waiters.forEach(function (fn) { try { fn(isStickAdd); } catch (e) {} });
    if (isStickAdd) {
      // Fallback for add flows that never call showThemeModal (e.g. quick-add
      // with the popup disabled). openDrawer() de-dupes against the hook.
      setTimeout(openDrawer, 500);
    }
  }

  // Resolves whether the add tied to the current popup was a stick. The theme
  // calls showThemeModal in its fetch .then; our signalAdd fires a tick later
  // off the cloned response — so we wait briefly for it rather than racing.
  function decideStick() {
    return new Promise(function (resolve) {
      if (lastAdd && (Date.now() - lastAdd.at) < 1500) { resolve(lastAdd.isStick); return; }
      var done = false;
      function finish(v) { if (done) return; done = true; resolve(v); }
      addWaiters.push(finish);
      setTimeout(function () { finish(false); }, 900); // default: let the native popup show
    });
  }

  function inspectAddResponse(text) {
    if (!text) return;
    var data;
    try { data = JSON.parse(text); } catch (e) { return; }
    var items = data.items ? data.items : [data];
    // Ignore our own upsell adds (bundle / kina) so they don't re-trigger the drawer.
    var upsellIds = {};
    BUNDLE.variants.forEach(function (v) { upsellIds[String(v.id)] = true; });
    KINAS.forEach(function (k) { upsellIds[String(k.variantId)] = true; });
    var onlyUpsell = items.length && items.every(function (it) { return upsellIds[String(it.id || it.variant_id)]; });
    if (onlyUpsell) return;
    signalAdd(items.some(isStick));
  }

  function isAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  // Hook Showcase's showThemeModal: for stick-adds, suppress the native
  // "added to cart" popup and show our drawer instead. Everything else is
  // passed straight through unchanged.
  var _showThemeModal = null;
  function installModalHook() {
    var fn = window.showThemeModal;
    if (typeof fn !== 'function') return false;
    if (fn.__ooakWrapped) return true;
    _showThemeModal = fn;
    var wrapped = function (el, id, cb) {
      if (id === 'added-to-cart') {
        var self = this, args = arguments;
        decideStick().then(function (isStickAdd) {
          if (isStickAdd) openDrawer();
          else _showThemeModal.apply(self, args);
        });
        return;
      }
      return _showThemeModal.apply(this, arguments);
    };
    wrapped.__ooakWrapped = true;
    window.showThemeModal = wrapped;
    return true;
  }

  // Patch fetch
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url);
      var p = _fetch.apply(this, arguments);
      if (isAddUrl(url)) {
        p.then(function (res) {
          try { res.clone().text().then(inspectAddResponse).catch(function () {}); } catch (e) {}
          return res;
        }).catch(function () {});
      }
      return p;
    };
  }

  // Patch XHR (covers jQuery-based adds)
  (function () {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__ooakAdd = isAddUrl(url);
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__ooakAdd) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) inspectAddResponse(this.responseText);
        });
      }
      return _send.apply(this, arguments);
    };
  })();

  // Close on Escape.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sheet = document.getElementById('ooak-uc-sheet');
    if (sheet && sheet.classList.contains('show')) closeSheet();
  });

  // Install the modal hook as soon as showThemeModal exists (theme.js runs
  // before this deferred script, but keep polling in case it defines it later).
  (function hookWhenReady(tries) {
    if (installModalHook()) return;
    if (tries <= 0) return;
    setTimeout(function () { hookWhenReady(tries - 1); }, 100);
  })(60);

  // Passive entry point: someone who lands on /cart with a stick already in it.
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  onReady(function () {
    installModalHook();
    if (/\/cart\/?$/.test(window.location.pathname)) {
      setTimeout(function () { openFromCart(false); }, 300);
    }
  });
})();
